import "owl.carousel";
import CartObject from "../helpers/cartUtil";
import Util from "../helpers/util";
import favUtil from "../helpers/favutil";

// Using shared singleton instance
var UtilObject = new Util();
var favObject = new favUtil();

var spacing = "mb-3";
var customerFavList = 0;

//variable for type of the screen
var deviceTypeHomePage;

// import s3Util from "../helpers/s3Util";
// var s3Object = new s3Util();

//Loading and using Google maps helper functions
import GoogleMapsApi from "../helpers/GoogleMapsApi";
var GoogleMapsApiObjectVendor = new GoogleMapsApi();

import { getImageUrl, getVendorBusinessImageUrl } from "../helpers/mediaUrl";
import { buildProductCard, buildVendorCard } from "../helpers/cardComponents";

const VendorService = {
  normalizeList(res) {
    if (Array.isArray(res)) return res;
    if (res && Array.isArray(res.NearMe)) return res.NearMe;
    return [];
  },
};
export default class HomePage {
  addToCartInFlight = new Set();
  vendorIdCacheByProductId = {};
  constructor() {
    console.log("HOMEPAGE FILE LOADED V2 - MODERN OFFERS");
    //HomePage Part
    this.grid = $(".homePage");
    this.filterBtn = $(".filterBtn");
    this.state = {
      isFilterActive: false,
      categories: [],
      nearYouPendingRequests: 0,
      nearYouRenderedAny: false,
      topProducts: [],
      activeTpFilter: "all",
      activeTpIntent: null,
      // Track which sections returned data for "not in area" detection
      sectionResults: {
        offers: null,
        brands: null,
        categories: null,
        products: null,
      },
    };

    var allCookies = UtilObject.getAllCookies();

    //checking the size of the screen
    var screenWidthHp = $(window).width();
    if (screenWidthHp < 768) {
      deviceTypeHomePage = "mobile";
      $(".homePageMobile").removeClass("d-none");
    } else {
      deviceTypeHomePage = "desktop";
      $(".homePageDesktop").removeClass("d-none");
    }

    //Registering Events
    this.bindEvents();
  }

  bindEvents = () => {
    console.log("bind event loaded");

    try {
      this.calOwlCarousel();
    } catch (err) {
      console.error("Locaso: HomePage calOwlCarousel failed", err);
    }
    try {
      this.getOffers();
    } catch (err) {
      console.error("Locaso: HomePage getOffers failed", err);
      this.clearSectionSkeleton(".homepage-skeleton-offers");
    }
    try {
      this.getCategories();
    } catch (err) {
      console.error("Locaso: HomePage getCategories failed", err);
      this.clearSectionSkeleton(".homepage-skeleton-categories");
    }
    try {
      this.getVendorByRating();
    } catch (err) {
      console.error("Locaso: HomePage getVendorByRating failed", err);
      this.clearSectionSkeleton(".homepage-skeleton-vendors");
      this.clearSectionSkeleton(".homepage-skeleton-nearyou");
    }
    try {
      this.getProductByRating();
    } catch (err) {
      console.error("Locaso: HomePage getProductByRating failed", err);
      this.clearSectionSkeleton(".homepage-skeleton-products-static");
    }

    // Failsafe: never let homepage remain in an infinite loading skeleton state.
    setTimeout(() => {
      this.clearSectionSkeleton(".homepage-skeleton-offers");
      this.clearSectionSkeleton(".homepage-skeleton-categories");
      this.clearSectionSkeleton(".homepage-skeleton-vendors");
      this.clearSectionSkeleton(".homepage-skeleton-nearyou");
      this.clearSectionSkeleton(".homepage-skeleton-products-static");
    }, 7000);

    // SAFE binding (prevents duplicates)
    $(".clear-Filter").off("click").on("click", this.clearHomepageFilter);
    this.filterBtn.off("click").on("click", this.filterOptions);
    $(".clearFilterHomepage")
      .off("click")
      .on("click", this.clearHomepageFilter);

    $(".tp-filter-tab").off("click").on("click", this.handleTopProductFilter);
  };

  calOwlCarousel = () => {
    const isDesktop = $(window).width() >= 992;
    $(".carousel_se_01_carousel").owlCarousel({
      nav: isDesktop,
      dots: false,
      mouseDrag: true,
      responsiveClass: true,
      responsive: {
        0: {
          items: 2,
          slideBy: 2,
        },
        768: {
          items: 2,
          slideBy: 2,
        },
        992: {
          items: 4,
          slideBy: 4,
        },
        1200: {
          items: 4,
          slideBy: 4,
        },
      },
    });

    // Top Categories Carousel
    $(".top-categories-carousel").owlCarousel({
      nav: isDesktop,
      dots: false,
      mouseDrag: true,
      responsiveClass: true,
      responsive: {
        0: {
          items: 3,
          slideBy: 3,
        },
        768: {
          items: 4,
          slideBy: 4,
        },
        992: {
          items: 6,
          slideBy: 6,
        },
        1200: {
          items: 6,
          slideBy: 6,
        },
      },
    });

    //For Offers
    $(".carousel_se_03_carousel").owlCarousel({
      nav: false,
      rewind: false,
      dots: true,
      autoplay: true,
      autoplayTimeout: 5000,
      smartSpeed: 1000,
      animateIn: "linear",
      animateOut: "linear",
      autoplayHoverPause: true,
      loop: true,
      responsiveClass: true,
      responsive: {
        0: {
          items: 1.1,
          slideBy: 1,
        },
        480: {
          items: 2.1,
          slideBy: 2,
        },
        // 600: {
        //   items: 2.1,
        //   slideBy: 2,
        // },
        // 767: {
        //   items: 3.1,
        //   slideBy: 2,
        // },
        // 992: {
        //   items: 3,
        //   slideBy: 2,
        // },
        1200: {
          items: 3,
          slideBy: 2,
        },
      },
    });
  };

  clearCarousel = (selector) => {
    const carousel = $(selector);
    const len = carousel.find(".owl-item").length;

    for (let i = 0; i < len; i++) {
      carousel.owlCarousel("remove", 0);
    }
  };

  clearSectionSkeleton = (selector) => {
    $(selector).remove();
  };

  resolveVendorIdFromProduct = (product = {}) => {
    const candidates = [
      product.Vendor_ID,
      product.Vendor_Id,
      product.VendorID,
      product.vendor_id,
      product.vendorId,
      product.Business_ID,
      product.Business_Id,
      product.business_id,
    ];

    for (const candidate of candidates) {
      const value = String(candidate || "").trim();
      if (value) {
        return value;
      }
    }
    return null;
  };

  getProductSummaryForCart = (productId) => {
    if (this.vendorIdCacheByProductId[productId]) {
      return Promise.resolve({
        Vendor_ID: this.vendorIdCacheByProductId[productId],
      });
    }

    return new Promise((resolve) => {
      $.ajax({
        url:
          globalThis.baseURL + "api/customer/ProductSummary/getProductSummary",
        type: "POST",
        data: { Product_ID: productId },
        headers: { Authorization: globalThis.X_API_KEY },
        success: (result) => {
          const resolvedVendorId = String(result?.Vendor_ID || "").trim();
          if (resolvedVendorId) {
            this.vendorIdCacheByProductId[productId] = resolvedVendorId;
          }
          resolve(result || null);
        },
        error: () => resolve(null),
      });
    });
  };

  addToCartRequest = (payload) => {
    return new Promise((resolve, reject) => {
      $.ajax({
        url: globalThis.baseURL + "api/customer/Cart/AddtoCart",
        type: "POST",
        data: payload,
        headers: { Authorization: globalThis.X_API_KEY },
        success: (result) => resolve(result),
        error: (err) => reject(err),
      });
    });
  };

  clearExistingCartAndReset = () => {
    return new Promise((resolve) => {
      const allCookies = UtilObject.getAllCookies() || {};
      const orderId =
        localStorage.getItem("ORDER_ID") || allCookies.ORDER_ID || "";
      if (!orderId) {
        resolve(false);
        return;
      }
      $.ajax({
        url: globalThis.baseURL + "api/customer/Cart/DeleteCart",
        type: "POST",
        data: { Order_ID: orderId },
        headers: { Authorization: globalThis.X_API_KEY },
        success: () => {
          CartObject.notifyCartUpdate();
          resolve(true);
        },
        error: () => resolve(false),
      });
    });
  };

  ensureVendorSwitchModal = () => {
    if ($("#showCartModal").length) {
      return;
    }
    const modalHtml = `
      <div class="modal fade" id="showCartModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content border-0 shadow-lg">
            <div class="modal-header bg-light">
              <h5 class="modal-title fw-bold">Switch Vendor?</h5>
            </div>
            <div class="modal-body py-4">
              <p class="mb-0">You already have items from another vendor in your cart. Do you want to clear current cart and add this item?</p>
            </div>
            <div class="modal-footer border-0">
              <button type="button" class="btn btn-light rounded-pill px-4 keepOldCart" data-bs-dismiss="modal">Keep Old Cart</button>
              <button type="button" class="btn text-white rounded-pill px-4 startNewCart" style="background: #ff385c;">Yes, Start Fresh</button>
            </div>
          </div>
        </div>
      </div>
    `;
    $("body").append(modalHtml);
  };

  askVendorSwitchConfirmation = () => {
    return new Promise((resolve) => {
      this.ensureVendorSwitchModal();
      const $modal = $("#showCartModal");
      const modalInstance = bootstrap.Modal.getOrCreateInstance($modal[0]);

      const cleanup = () => {
        $modal.off("hidden.bs.modal.vendorSwitch");
        $modal.find(".startNewCart").off("click.vendorSwitch");
        $modal.find(".keepOldCart").off("click.vendorSwitch");
      };

      $modal.one("hidden.bs.modal.vendorSwitch", () => {
        cleanup();
        resolve(false);
      });

      $modal.find(".startNewCart").one("click.vendorSwitch", () => {
        cleanup();
        modalInstance.hide();
        resolve(true);
      });

      $modal.find(".keepOldCart").one("click.vendorSwitch", () => {
        cleanup();
        modalInstance.hide();
        resolve(false);
      });

      modalInstance.show();
    });
  };

  getSessionCache = (key, ttlMs) => {
    try {
      const raw = sessionStorage.getItem(key);
      if (!raw) return null;
      const parsed = JSON.parse(raw);
      if (!parsed || !parsed.at) return null;
      if (Date.now() - parsed.at > ttlMs) return null;
      return parsed.data;
    } catch (e) {
      return null;
    }
  };

  setSessionCache = (key, data) => {
    try {
      sessionStorage.setItem(
        key,
        JSON.stringify({
          at: Date.now(),
          data,
        }),
      );
    } catch (e) {}
  };

  getVendorByRating = () => {
    const cacheKey = `locaso:homepage:vendors:${Math.round((globalThis.LAT || 0) * 100)}:${Math.round((globalThis.LNG || 0) * 100)}:${globalThis.BUFFER || 100}`;
    const cached = this.getSessionCache(cacheKey, 15000);
    if (cached) {
      this.state.sectionResults.brands =
        Array.isArray(cached) && cached.length > 0;
      this.checkAllSectionsEmpty();
      this.showVendorsOnHomepage(cached);
      return;
    }

    if (!globalThis.LAT || !globalThis.LNG) {
      $.ajax({
        url: globalThis.baseURL + "api/customer/Homepage/vendorByRating",
        type: "GET",
        headers: { Authorization: globalThis.X_API_KEY },
        success: (result) => {
          this.setSessionCache(cacheKey, result);
          this.state.sectionResults.brands =
            Array.isArray(result) && result.length > 0;
          this.checkAllSectionsEmpty();
          this.showVendorsOnHomepage(result);
        },
        error: (result) => {
          this.state.sectionResults.brands = false;
          this.checkAllSectionsEmpty();
          this.clearSectionSkeleton(".homepage-skeleton-vendors");
        },
      });
      return;
    }

    $.ajax({
      url:
        globalThis.baseURL + "api/customer/Homepage/vendorByRatingWithLocation",
      type: "POST",
      data: {
        buffer: globalThis.BUFFER,
        lat: globalThis.LAT,
        lon: globalThis.LNG,
      },
      headers: { Authorization: globalThis.X_API_KEY },
      success: (result) => {
        this.setSessionCache(cacheKey, result);
        this.state.sectionResults.brands =
          Array.isArray(result) && result.length > 0;
        this.checkAllSectionsEmpty();
        this.showVendorsOnHomepage(result);
      },
      error: (result) => {
        this.state.sectionResults.brands = false;
        this.checkAllSectionsEmpty();
        this.clearSectionSkeleton(".homepage-skeleton-vendors");
      },
    });
  };

  //name the parameters properly
  showVendorsOnHomepage = async (result) => {
    this.clearSectionSkeleton(".homepage-skeleton-vendors");
    this.clearCarousel(".owl-carousel.top-vendors-items");

    const cards = await Promise.all(result.map((v) => this.buildVendorCard(v)));

    cards.forEach((card) => {
      $(".owl-carousel.top-vendors-items").owlCarousel("add", card);
    });

    $(".owl-carousel.top-vendors-items").owlCarousel("update");
  };

  getCategories = () => {
    // Use location-aware endpoint when we have coordinates
    if (globalThis.LAT && globalThis.LNG) {
      UtilObject.getCategoriesWithLocation(
        globalThis.LAT,
        globalThis.LNG,
        globalThis.BUFFER,
        (result) => {
          this.showCategoriesOnHomepage(result);
        },
      );
    } else {
      UtilObject.getCategories((result) => {
        this.showCategoriesOnHomepage(result);
      });
    }
  };

  //use query parameter to pass to php controller
  showCategoriesOnHomepage = async (result) => {
    this.clearSectionSkeleton(".homepage-skeleton-categories");
    this.clearCarousel(".owl-carousel.top-categories-items");
    //fav check
    this.checkFavourites();

    this.state.categories = result;

    // Track section result
    this.state.sectionResults.categories =
      Array.isArray(result) && result.length > 0;
    this.checkAllSectionsEmpty();

    for (const element of result) {
      const categoryImg = getImageUrl(element.Icon_Url);

      var item = `
      <div class="item">
        <div class="wow fadeInUp delay-2 d-flex justify-content-center">
          <div class="text-center category-card-modern">
            <a class="category-squircle" href="${globalThis.baseURL}customer/vendorListingPage/${element.Picklist_display_value}" title="Browse ${element.Picklist_display_value}">
              <div class="category-icon-wrap">
                <img loading="lazy" src="${categoryImg}" alt="${element.Picklist_display_value}">
              </div>
            </a>
            <h6 class="category-name mt-2 mb-0">${element.Picklist_display_value}</h6>
          </div>
        </div>
      </div>`;

      $(".owl-carousel.top-categories-items").owlCarousel("add", item);
    }

    $(".owl-carousel.top-categories-items").owlCarousel("update");
    //calling near you vendors on homepage

    this.nearYouCategoriesVendor();
  };

  nearYouCategoriesVendor = async (buffer = globalThis.BUFFER) => {
    //  STOP if filter is active
    if (this.state.isFilterActive) return;
    await this.checkFavourites();

    $(".near-you-section").empty();
    this.showNearYouSkeleton();
    this.state.nearYouRenderedAny = false;
    this.state.nearYouPendingRequests = this.state.categories.length;
    if (!this.state.nearYouPendingRequests) {
      this.clearSectionSkeleton(".homepage-skeleton-nearyou");
      return;
    }

    $.ajax({
      url:
        globalThis.baseURL +
        "api/customer/VendorsList/getVendorByCategoryLimitBatch",
      type: "POST",
      data: {
        buffer,
        lat: globalThis.LAT,
        lon: globalThis.LNG,
        Picklist_IDs: JSON.stringify(
          this.state.categories.map((category) => category.Picklist_ID),
        ),
      },
      headers: { Authorization: globalThis.X_API_KEY },

      success: async (res) => {
        if (!res || typeof res !== "object") {
          this.clearSectionSkeleton(".homepage-skeleton-nearyou");
          return;
        }

        for (const category of this.state.categories) {
          const categoryResult = res[category.Picklist_ID];
          this.state.nearYouPendingRequests -= 1;

          if (
            !categoryResult ||
            !Array.isArray(categoryResult.NearMe) ||
            categoryResult.NearMe.length === 0
          ) {
            continue;
          }

          const vendors = categoryResult.NearMe;
          const first = vendors[0];
          this.state.nearYouRenderedAny = true;
          this.clearSectionSkeleton(".homepage-skeleton-nearyou");
          await this.renderCategorySection(first, vendors, category);
        }

        if (this.state.nearYouPendingRequests <= 0) {
          this.clearSectionSkeleton(".homepage-skeleton-nearyou");
        }
      },

      error: () => {
        this.state.nearYouPendingRequests = 0;
        this.clearSectionSkeleton(".homepage-skeleton-nearyou");
        console.error("Category vendor batch fetch failed");
      },
    });
  };

  showNearYouSkeleton = () => {
    const sectionSkeleton = Array.from({ length: 2 })
      .map(
        () => `
      <section class="carousel_se_02 home-section-card near-you-block homepage-skeleton-block">
        <div class="container-fluid">
          <div class="homepage-skeleton-line w-40 homepage-skeleton-shimmer mb-3"></div>
          <div class="homepage-skeleton-nearyou-grid">
            ${Array.from({ length: 4 })
              .map(
                () => `
              <div class="homepage-skeleton-vendor-card">
                <div class="homepage-skeleton-vendor-img homepage-skeleton-shimmer"></div>
                <div class="homepage-skeleton-vendor-body">
                  <div class="homepage-skeleton-line w-80 homepage-skeleton-shimmer"></div>
                  <div class="homepage-skeleton-line w-60 homepage-skeleton-shimmer"></div>
                </div>
              </div>
            `,
              )
              .join("")}
          </div>
        </div>
      </section>
    `,
      )
      .join("");
    $(".near-you-section").html(
      `<div class="homepage-skeleton-wrap homepage-skeleton-nearyou">${sectionSkeleton}</div>`,
    );
  };

  renderCategorySection = async (first, vendors, category) => {
    const sectionClass = `${first.Picklist_ID}-near-you-items`;

    const parentHTML = `
<section class="carousel_se_02 home-section-card near-you-block">
  <div class="container-fluid">
    <div class="section-header-modern mb-3">
      <div class="section-header-left">
        <p class="section-eyebrow">FEATURED</p>
        <h3 class="section-title">${first.Picklist_display_value}</h3>
      </div>
      <a href="${globalThis.baseURL}customer/vendorListingPage/${category.Picklist_display_value}"
         class="section-view-all">
        View All
        <i class="fa-solid fa-arrow-right"></i>
      </a>
    </div>
    <div class="owl-carousel ${sectionClass}"></div>
  </div>
</section>
  `;

    $(".near-you-section").append(parentHTML);

    const carousel = $(`.${sectionClass}`);
    const isDesktop = $(window).width() >= 768;
    carousel.owlCarousel({
      nav: isDesktop,
      mouseDrag: true,
      margin: 8,
      responsive: {
        0: { items: 2, slideBy: 2 },
        992: { items: 4, slideBy: 4 },
      },
    });

    const items = await Promise.all(
      vendors.map((v) => this.buildVendorCard(v)),
    );

    items.forEach((item) => {
      carousel.owlCarousel("add", item);
    });

    carousel.owlCarousel("update");
  };
  buildVendorCard = async (v) => {
    const fav = await this.checkFavourites("check", v.Vendor_ID);
    return buildVendorCard(v, { isCarousel: true, favBtn: fav });
  };

  getOffers = () => {
    const cacheKey = `locaso:homepage:offers:${Math.round((globalThis.LAT || 0) * 100)}:${Math.round((globalThis.LNG || 0) * 100)}:${globalThis.BUFFER || 100}`;
    const cached = this.getSessionCache(cacheKey, 15000);
    if (cached) {
      this.state.sectionResults.offers =
        Array.isArray(cached) && cached.length > 0;
      this.checkAllSectionsEmpty();
      this.showOffersOnHomepage(cached);
      return;
    }

    $.ajax({
      url: globalThis.baseURL + "api/customer/Homepage/getNearByOffers",
      type: "POST",
      data: {
        buffer: globalThis.BUFFER,
        lat: globalThis.LAT,
        lon: globalThis.LNG,
      },
      headers: { Authorization: globalThis.X_API_KEY },
      success: (result) => {
        this.setSessionCache(cacheKey, result);
        this.state.sectionResults.offers =
          Array.isArray(result) && result.length > 0;
        this.checkAllSectionsEmpty();
        this.showOffersOnHomepage(result);
      },
      error: () => {
        this.state.sectionResults.offers = false;
        this.checkAllSectionsEmpty();
        this.clearSectionSkeleton(".homepage-skeleton-offers");
        $(".owl-carousel.offers-items").hide();
        $(".carousel_se_03").addClass("d-none");
      },
    });
  };

  showOffersOnHomepage = async (result) => {
    console.log("SHOWING OFFERS:", result);
    this.clearSectionSkeleton(".homepage-skeleton-offers");
    if (!Array.isArray(result) || result.length === 0) {
      $(".owl-carousel.offers-items").hide();
      $(".carousel_se_03").addClass("d-none");
      return;
    }

    const carousel = $(".owl-carousel.offers-items");

    $(".carousel_se_03").removeClass("d-none");
    carousel.show();

    //  Clear existing items
    this.clearCarousel(".owl-carousel.offers-items");

    // Build items in parallel
    const items = await Promise.all(
      result.map(async (offer) => {
        let page = `${globalThis.baseURL}customer/allOffers`;

        const goToPage = (
          offer.Go_To_Page ||
          offer.go_to_page ||
          ""
        ).toLowerCase();
        const offerData = offer.data || offer.offer_data || offer.Offer_Data;

        if (goToPage === "vendor" && offerData) {
          page = `${globalThis.baseURL}customer/productListing/${offerData}`;
        } else if (goToPage === "category" && offerData) {
          page = `${globalThis.baseURL}customer/vendorListingPage/${offerData}`;
        } else if (!goToPage && offer.Vendor_URL) {
          // Fallback: Use joined Vendor_URL if explicit routing is missing
          page = `${globalThis.baseURL}customer/productListing/${offer.Vendor_URL}`;
        }

        const offerImage = getImageUrl(offer.Image_Url);

        return `
        <div class="item">
          <div class="mb-3">
            <a href="${page}" class="homepage-offers offers-card-modern d-block position-relative">
              <div class="offers-card-bg" style="background-image: url('${offerImage}');"></div>
              <div class="offers-card-content">
                <span class="offers-card-badge">FRESH DEAL</span>
                <h4 class="offers-card-brand text-truncate">${offer.Offer_Name || ""}</h4>
                <p class="offers-card-terms">On all orders above ₹199</p>
              </div>
            </a>
          </div>
        </div>
      `;
      }),
    );

    // Add all items first
    items.forEach((item) => {
      carousel.owlCarousel("add", item);
    });

    //  Single update
    carousel.owlCarousel("update");
  };

  //top products
  getProductByRating = () => {
    const cacheKey = `locaso:homepage:products:${Math.round((globalThis.LAT || 0) * 100)}:${Math.round((globalThis.LNG || 0) * 100)}:${globalThis.BUFFER || 100}`;
    const cached = this.getSessionCache(cacheKey, 15000);
    if (cached) {
      this.state.sectionResults.products =
        Array.isArray(cached) && cached.length > 0;
      this.checkAllSectionsEmpty();
      this.showProductsOnHomepage(cached);
      return;
    }

    $.ajax({
      url:
        globalThis.baseURL +
        "api/customer/Homepage/productByRatingWithLocation",
      type: "POST",
      data: {
        buffer: globalThis.BUFFER,
        lat: globalThis.LAT,
        lon: globalThis.LNG,
      },
      headers: { Authorization: globalThis.X_API_KEY },
      success: (result) => {
        this.setSessionCache(cacheKey, result);
        this.state.sectionResults.products =
          Array.isArray(result) && result.length > 0;
        this.checkAllSectionsEmpty();
        this.showProductsOnHomepage(result);
      },
      error: (result) => {
        this.state.sectionResults.products = false;
        this.checkAllSectionsEmpty();
        this.clearSectionSkeleton(".homepage-skeleton-products-static");
        this.clearProductCarousel();
      },
    });
  };

  showProductsOnHomepage = async (result) => {
    console.log("PRODUCT API RESULT:", result);

    if (!Array.isArray(result)) {
      console.error(
        "[HomePage] Error: Expected product array but received:",
        typeof result,
      );
      this.clearSectionSkeleton(".homepage-skeleton-products-static");
      return;
    }

    this.clearSectionSkeleton(".homepage-skeleton-products-static");

    if (!Array.isArray(result) || result.length === 0) {
      $(".top-products").hide();
      return;
    }

    // Save to state for filtering
    this.state.topProducts = result;

    $(".top-products").show();

    this.renderTopProducts();
  };

  handleTopProductFilter = (event) => {
    const btn = $(event.currentTarget);
    const filter = btn.data("tp-filter");
    const intent = btn.data("tp-intent");

    // UI Update
    $(".tp-filter-tab").removeClass("active");
    btn.addClass("active");

    this.state.activeTpFilter = filter;
    this.state.activeTpIntent = intent;

    this.renderTopProducts();
  };

  renderTopProducts = async () => {
    // Ensure we have an array and filter out any invalid/empty products
    let products = [...(this.state.topProducts || [])].filter(
      (p) => p && p.Product_ID && p.Product_Service_Name,
    );

    // 1. Filter Logic
    if (this.state.activeTpFilter !== "all") {
      products = products.filter((p) => {
        const isTypeMatch = p.Picklist_sub_type === this.state.activeTpFilter;

        // If it's a "Product", we can further differentiate by intent (food vs shop)
        if (isTypeMatch && this.state.activeTpFilter === "Product") {
          const isFood = parseInt(p.is_food) === 1;

          if (this.state.activeTpIntent === "food") return isFood;
          if (this.state.activeTpIntent === "shop") return !isFood;
        }

        return isTypeMatch;
      });
    } else {
      // 2. Logical Grouping for "All" view (Food -> Shopping -> Services)
      products.sort((a, b) => {
        const catA = (a.Category_Name || "").toLowerCase();
        const catB = (b.Category_Name || "").toLowerCase();
        const foodCats = [
          "restaurants",
          "bakery",
          "tiffin service",
          "fruits",
          "vegetables",
          "meat",
          "fish",
        ];

        const isFoodA = foodCats.some((fc) => catA.includes(fc));
        const isFoodB = foodCats.some((fc) => catB.includes(fc));

        if (isFoodA && !isFoodB) return -1;
        if (!isFoodA && isFoodB) return 1;

        // If both are food or both are not, sort by Sub Type
        if (
          a.Picklist_sub_type === "Product" &&
          b.Picklist_sub_type === "Service"
        )
          return -1;
        if (
          a.Picklist_sub_type === "Service" &&
          b.Picklist_sub_type === "Product"
        )
          return 1;

        return 0;
      });
    }

    // Limit to 10 as per user request
    products = products.slice(0, 10);

    // Build all product cards
    const productCards = await Promise.all(
      products.map((product) => this.buildProductCardCarousel(product)),
    );

    // Update both desktop and mobile carousels
    const carouselSelectors = [
      ".owl-carousel.top-products-items",
      ".owl-carousel.top-products-items-mobile",
    ];

    carouselSelectors.forEach((selector) => {
      const carousel = $(selector);

      // Destroy safely
      if (carousel.hasClass("owl-loaded")) {
        carousel.owlCarousel("destroy");
      }
      carousel.removeClass("owl-loaded owl-drag");
      carousel.empty();

      const isDesktop = $(window).width() >= 768;
      // Initialize carousel
      carousel.owlCarousel({
        nav: isDesktop,
        mouseDrag: true,
        margin: 12,
        responsive: {
          0: { items: 2, slideBy: 2 },
          992: { items: 4, slideBy: 4 },
        },
      });

      // Add all product cards
      productCards.forEach((card) => {
        carousel.owlCarousel("add", card);
      });

      carousel.owlCarousel("update");
    });

    this.loadProductImages(products);
    $(".top-products-items .addToCartBtn")
      .off("click")
      .on("click", this.addItemInCart);
    $(".top-products-items-mobile .addToCartBtn")
      .off("click")
      .on("click", this.addItemInCart);
  };
  filterOptions = (event) => {
    $(".filterBtnToggle").removeClass("filterBtnToggle");
    $(".clearFilterHomepage").removeClass("d-none");

    const classList = event.currentTarget.classList;

    const filterClass = [...classList].find(
      (c) =>
        c.startsWith("price") ||
        c.startsWith("delivery") ||
        c.startsWith("rating"),
    );

    const filterOptions = filterClass ? filterClass.split("-") : [];

    //  GUARD
    if (!filterOptions.length) {
      console.warn("Invalid filter click");
      return;
    }

    this.checkFavourites();

    if (filterOptions[0] === "price") {
      const order = filterOptions[1];

      $(".no-filter-option").addClass("d-none");
      $(`.price-${order}`).addClass("filterBtnToggle");

      this.filterProductsByPrice(order);
    }

    if (filterOptions[0] === "delivery") {
      const buffer = filterOptions[1];

      $(".no-filter-option").addClass("d-none");
      $(".top-products").hide();
      $(".top-vendors").show();

      $(`.delivery-${buffer}`).addClass("filterBtnToggle");

      this.filterVendorsByDelivery(buffer);
    }
  };

  filterProductsByPrice = (order) => {
    console.log("API CALL TRIGGERED", order);
    if (!LAT || !LNG) {
      console.error("LAT/LNG missing");
      return;
    }

    $.ajax({
      url: globalThis.baseURL + "api/customer/Homepage/productByPrice",
      type: "POST",
      data: { order },
      headers: { Authorization: globalThis.X_API_KEY },

      success: (result) => {
        console.log("API RESULT:", result);
        this.renderProductsByPrice(result);
      },

      error: () => {
        console.error("Failed to fetch products by price");
      },
    });
  };

  filterVendorsByDelivery = (buffer) => {
    console.log("DELIVERY FILTER", buffer);
    this.state.isFilterActive = true;
    $.ajax({
      url: globalThis.baseURL + "api/customer/VendorsList/getNearByVendors",
      type: "POST",
      data: {
        buffer,
        lat: LAT,
        lon: LNG,
      },
      headers: { Authorization: globalThis.X_API_KEY },

      success: (result) => {
        const vendors = VendorService.normalizeList(result);

        $(".top-products").hide();
        $(".top-vendors").show();

        if (!vendors.length) {
          $(".no-filter-option").removeClass("d-none");
        } else {
          $(".no-filter-option").addClass("d-none");
        }

        this.renderVendors(vendors);
      },

      error: () => {
        console.error("Delivery filter failed");
      },
    });
  };

  renderProductsByPrice = async (products) => {
    console.log("RENDERING PRODUCTS", products.length);
    $(".top-vendors").hide();
    $(".top-products").show();

    this.clearProductCarousel();

    if (!Array.isArray(products) || products.length === 0) {
      $(".no-filter-option").removeClass("d-none");
      return;
    }

    $(".no-filter-option").addClass("d-none");

    // Build all product cards once
    const productCards = await Promise.all(
      products.map((product) => this.buildProductCardCarousel(product)),
    );

    // Update both desktop and mobile carousels
    const carouselSelectors = [
      ".owl-carousel.top-products-items",
      ".owl-carousel.top-products-items-mobile",
    ];

    carouselSelectors.forEach((selector) => {
      const carousel = $(selector);

      // Destroy safely
      if (carousel.hasClass("owl-loaded")) {
        carousel.owlCarousel("destroy");
      }

      carousel.empty();

      const isDesktop = $(window).width() >= 768;
      // Initialize carousel
      carousel.owlCarousel({
        nav: isDesktop,
        mouseDrag: true,
        margin: 12,
        responsive: {
          0: { items: 2, slideBy: 2 },
          992: { items: 4, slideBy: 4 },
        },
      });

      // Add all product cards
      productCards.forEach((card) => {
        carousel.owlCarousel("add", card);
      });

      carousel.owlCarousel("update");
    });

    // Load images async (non-blocking)
    this.loadProductImages(products);
  };

  renderVendors = async (vendors) => {
    if (!Array.isArray(vendors)) {
      console.error("Expected array, got:", vendors);
      return;
    }

    const carousel = $(".owl-carousel.top-vendors-items");

    this.clearCarousel(".owl-carousel.top-vendors-items");

    //  Build cards in parallel
    const cards = await Promise.all(
      vendors.map((v) => this.buildVendorCard(v)),
    );

    //  ADD items first (no update spam)
    cards.forEach((card) => {
      carousel.owlCarousel("add", card);
    });

    carousel.owlCarousel("update");
  };

  clearProductCarousel = () => {
    const carouselSelectors = [
      ".owl-carousel.top-products-items",
      ".owl-carousel.top-products-items-mobile",
    ];

    carouselSelectors.forEach((selector) => {
      const carousel = $(selector);

      // Destroy the carousel instance if it exists
      if (carousel.hasClass("owl-loaded")) {
        carousel.owlCarousel("destroy");
      }

      // Clear all items
      carousel.empty();
    });
  };

  buildProductCardCarousel = async (product) => {
    return buildProductCard(product, { isCarousel: true });
  };
  loadProductImages = async (products) => {
    await Promise.all(
      products.map(async (product) => {
        const imgUrl = getImageUrl(product.Image_URL);
        $(`.${product.Product_ID}-img`).attr("src", imgUrl);
      }),
    );
  };

  setFavourites = async (event) => {
    const btn = $(event.currentTarget);
    const vendorID = btn.val();

    const isLiked = btn.hasClass("liked");

    try {
      const result = await favObject.favouritesToggle(
        vendorID,
        isLiked ? "false" : "true",
      );

      if (result === "YOU NEED TO LOG IN") {
        $("#favouritesError").modal("show");
        return;
      }

      if (result === "ERROR OCCURED") return;

      // UI update only after success
      btn.toggleClass("liked");

      btn.html(
        isLiked
          ? `<i class="fa-solid fa-heart"></i>`
          : `<i class="fa-regular fa-heart"></i>`,
      );

      // update state
      if (this.favSet) {
        isLiked ? this.favSet.delete(vendorID) : this.favSet.add(vendorID);
      }
    } catch (e) {
      console.error("Favourite toggle failed", e);
    }
  };

  checkFavourites = async (type = "get", id = "") => {
    if (type === "get") {
      if (this.favouritesLoaded) return;

      this.favouritesLoaded = true;

      const cookies = UtilObject.getAllCookies();

      if (!cookies.hasOwnProperty("CUSTOMER_ID")) {
        this.favSet = new Set();
        return;
      }

      try {
        const result = await $.ajax({
          url: globalThis.baseURL + "api/customer/Account/getFavorites",
          type: "GET",
          headers: { Authorization: X_API_KEY },
        });

        customerFavList = result;
        this.favSet = new Set(result.map((f) => f.Vendor_ID));
      } catch {
        this.favSet = new Set();
      }
    } else {
      // SAFETY GUARD
      if (!this.favSet) return "";

      return this.favSet.has(id)
        ? `<button class="like-button likeBtnHomepage liked" value="${id}">
           <i class="fa-solid fa-heart"></i>
         </button>`
        : `<button class="like-button likeBtnHomepage" value="${id}">
           <i class="fa-regular fa-heart"></i>
         </button>`;
    }
  };

  clearHomepageFilter = () => {
    console.log("CLEAR FILTER");
    //Changing Color
    $(".filterBtnToggle").removeClass("filterBtnToggle");
    $(".clearFilterHomepage").addClass("d-none");
    //Show top categories
    $(".top-categories").show();
    $(".top-vendors").show();
    $(".top-products").show();

    this.state.isFilterActive = false;
    this.state.activeTpFilter = "all";
    this.state.activeTpIntent = null;
    $(".tp-filter-tab").removeClass("active");
    $('.tp-filter-tab[data-tp-filter="all"]').addClass("active");

    this.resetSectionResults();
    //show top brands again
    this.getVendorByRating();

    //show products
    this.getProductByRating();

    //show categories (this also triggers nearYouCategoriesVendor)
    this.getCategories();
  };

  // ─── "Not in your area" detection ────────────────────────────────────────────
  checkAllSectionsEmpty = () => {
    const r = this.state.sectionResults;
    // Wait until all four sections have reported
    if (
      r.offers === null ||
      r.brands === null ||
      r.categories === null ||
      r.products === null
    ) {
      return;
    }

    const allEmpty = !r.offers && !r.brands && !r.categories && !r.products;
    if (allEmpty) {
      this.showNotInAreaMessage();
    } else {
      this.hideNotInAreaMessage();
    }
  };

  showNotInAreaMessage = () => {
    $(".homepage-not-in-area").removeClass("d-none");
    // Hide content sections to keep the page clean
    $(
      ".carousel_se_01, .carousel_se_02, .carousel_se_03, .top-products, .top-vendors, .near-you-section, .filter, .trust-markers, .homepage-skeleton-products-static",
    ).hide();
  };

  hideNotInAreaMessage = () => {
    $(".homepage-not-in-area").addClass("d-none");
    $(
      ".carousel_se_01, .carousel_se_02, .carousel_se_03, .top-products, .top-vendors, .near-you-section, .filter, .homepage-skeleton-products-static",
    ).show();
  };

  resetSectionResults = () => {
    // Clear session cache for homepage sections to ensure fresh data on location change
    try {
      Object.keys(sessionStorage).forEach((key) => {
        if (key.startsWith("locaso:homepage:")) {
          sessionStorage.removeItem(key);
        }
      });
    } catch (e) {}

    this.state.sectionResults = {
      offers: null,
      brands: null,
      categories: null,
      products: null,
    };
    this.hideNotInAreaMessage();
  };

  addItemInCart = async (event) => {
    const pID = String(event.currentTarget.value || "").trim();
    const $btn = $(event.currentTarget);

    if (this.addToCartInFlight.has(pID)) {
      return;
    }

    this.addToCartInFlight.add(pID);
    const originalText = $btn.text();
    $btn.prop("disabled", true).text("ADDING...");

    let vIDRaw = String($(event.currentTarget).data("vendor") || "").trim();

    if (!vIDRaw) {
      const fromState = (this.state.topProducts || []).find(
        (p) => String(p.Product_ID || "").trim() === pID,
      );
      vIDRaw = this.resolveVendorIdFromProduct(fromState || {}) || "";
    }

    // Always validate vendor from product summary (source of truth for cart mapping)
    const summaryForVendor = await this.getProductSummaryForCart(pID);
    const summaryVendorId = String(summaryForVendor?.Vendor_ID || "").trim();
    if (summaryVendorId) {
      vIDRaw = summaryVendorId;
    }

    if (!pID || !vIDRaw) {
      console.warn("Locaso: Invalid cart payload", { pID, vIDRaw });
      if (window.$ && $("#addToCartError").length) {
        $(".addToCartErrorMessage").html(
          "This item is not available for cart.",
        );
        window.$("#addToCartError").modal("show");
      }
      $btn.prop("disabled", false).text(originalText);
      this.addToCartInFlight.delete(pID);
      return;
    }

    let cartState = null;
    try {
      cartState = await CartObject.cartCheck();
    } catch (e) {
      cartState = null;
    }
    const currentCartVendorId = String(
      cartState?.vendor?.Vendor_ID || "",
    ).trim();
    if (currentCartVendorId && currentCartVendorId !== vIDRaw) {
      const shouldReplace = await this.askVendorSwitchConfirmation();
      if (!shouldReplace) {
        $btn.prop("disabled", false).text(originalText);
        this.addToCartInFlight.delete(pID);
        return;
      }
      const cleared = await this.clearExistingCartAndReset();
      if (!cleared) {
        if (window.$ && $("#addToCartError").length) {
          $(".addToCartErrorMessage").html(
            "Could not replace existing cart. Please try again.",
          );
          window.$("#addToCartError").modal("show");
        }
        $btn.prop("disabled", false).text(originalText);
        this.addToCartInFlight.delete(pID);
        return;
      }
      cartState = await CartObject.cartCheck(true);
    }

    const payload = {
      Vendor_ID: vIDRaw,
      Product_ID: pID,
      Quantity: 1,
      Type: "ADD",
      Total_Items: Array.isArray(cartState?.Products)
        ? cartState.Products.length
        : 0,
    };

    try {
      await this.addToCartRequest(payload);
      CartObject.notifyCartUpdate();
      $btn.text("ADDED").prop("disabled", true);
    } catch (err) {
      if (err?.status === 429) {
        try {
          await new Promise((r) => setTimeout(r, 900));
          await this.addToCartRequest(payload);
          CartObject.notifyCartUpdate();
          $btn.text("ADDED").prop("disabled", true);
        } catch (errRetry) {
          console.error("Locaso: Error adding to cart after retry", errRetry);
          $btn.prop("disabled", false).text(originalText);
        }
      } else if (err?.responseJSON?.code === "3") {
        // Vendor mismatch fallback: re-fetch summary and retry once with corrected vendor id.
        try {
          const summary = await this.getProductSummaryForCart(pID);
          const fixedVendorId = String(summary?.Vendor_ID || "").trim();
          if (fixedVendorId) {
            payload.Vendor_ID = fixedVendorId;
            await this.addToCartRequest(payload);
            CartObject.notifyCartUpdate();
            $btn.text("ADDED").prop("disabled", true);
          } else {
            console.error(
              "Locaso: Vendor mismatch and unable to resolve Vendor_ID",
              { pID, fixedVendorId },
            );
            $btn.prop("disabled", false).text(originalText);
          }
        } catch (errRetryVendor) {
          console.error(
            "Locaso: Error adding to cart after vendor-id retry",
            errRetryVendor,
          );
          $btn.prop("disabled", false).text(originalText);
        }
      } else {
        console.error("Locaso: Error adding to cart", err);
        $btn.prop("disabled", false).text(originalText);
      }
    } finally {
      this.addToCartInFlight.delete(pID);
    }
  };
}
